import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  PortfolioProvider,
  usePortfolioStateContext,
} from 'Components/UI/Portfolio/PortfolioContext';
import Visualization from 'Components/UI/Snapshot/Holdings/Visualization';
import HoldingsAccountList from 'Components/UI/Snapshot/Holdings/HoldingsAccountList';
import PortfolioQueryWidget from 'Components/UI/Snapshot/Holdings/PortfolioQueryWidget';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { useHistory, useLocation } from 'react-router';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    alignContent: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  list: {
    flexGrow: 2,
    minWidth: 'min(100vw, 650px)',
  },
  chart: {
    flexGrow: 1,
  },
  content: {
    display: 'flex',
    position: 'relative',
  },
  widget: {
    position: 'absolute',
    width: theme.dimensions.xs,
    left: 0,
    top: 0,
    zIndex: 200,
  },
});

function HoldingsContent({ classes, ...rest }) {
  const history = useHistory();
  const { portfolioCollection, loading } = usePortfolioStateContext();
  const [portfolio] = portfolioCollection || [];

  React.useEffect(() => {
    if (portfolioCollection) {
      const nextSearch = new URLSearchParams(history.location.search);
      nextSearch.set(
        'portfolioSelfLink',
        portfolioCollection.link('self').url(),
      );

      history.push({
        search: nextSearch.toString(),
      });
    }

    return () => {
      const nextSearch = new URLSearchParams(history.location.search);
      nextSearch.delete('portfolioSelfLink');
      history.push({
        search: nextSearch.toString(),
      });
    };
  }, [portfolioCollection]);

  return (
    <>
      <div className={classes.content}>
        <Visualization
          portfolio={portfolio}
          loading={loading}
          className={classes.chart}
          {...rest}
        />
        <PortfolioQueryWidget classes={{ root: classes.widget }} {...rest} />
      </div>
      <HoldingsAccountList className={classes.list} portfolio={portfolio} />
    </>
  );
}

HoldingsContent.propTypes = {
  classes: PropTypes.object.isRequired,
};

function Holdings({ classes, className }) {
  const { householdResource } = useSimpleHousehold();
  const search = new URLSearchParams(useLocation().search);
  const portfolioRel = householdResource
    ?.relationship('portfolio')
    .link('related');

  const searchSelf = search.get('portfolioSelfLink');
  if (searchSelf) {
    portfolioRel.attr('url', searchSelf);
  }

  return (
    <div className={classnames(classes.root, className)}>
      <PortfolioProvider portfolioRelationship={portfolioRel}>
        <HoldingsContent classes={classes} />
      </PortfolioProvider>
    </div>
  );
}

Holdings.defaultProps = {
  className: '',
};

Holdings.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Holdings);
